import { params, const_var } from "../../redux/reducers/reducer";
import { calculateLegsCount } from "../common/common.helper";

export const createLegsConditionHelpers = (getDeps = () => ({})) => {
	const getRuntimeDeps = () => (getDeps ? getDeps() : {}) || {};

	const CheckLeanLegsByResponseForCompare = (newParams, type) => {
		if (type == "leftLean") {
			let left_lean = const_var.post_data["building"].leanto.find((s) => s.leanto_type == 1);
			let j = 0;
			if (const_var.conditionArrForLeanCompare["left"] != undefined && const_var.conditionArrForLeanCompare["left"].length > 0) {
				for (let i = 0; i <= const_var.conditionArrForLeanCompare["left"].length - 1; i++) {
					const_var.conditionArrForLeanCompare["left"][i].min_width =
						const_var.conditionArrForLeanCompare["left"][i].min_width == "" || const_var.conditionArrForLeanCompare["left"][i].min_width == null
							? 0
							: const_var.conditionArrForLeanCompare["left"][i].min_width;
					const_var.conditionArrForLeanCompare["left"][i].min_height =
						const_var.conditionArrForLeanCompare["left"][i].min_height == "" || const_var.conditionArrForLeanCompare["left"][i].min_height == null
							? 0
							: const_var.conditionArrForLeanCompare["left"][i].min_height;
					if (
						const_var.conditionArrForLeanCompare["left"][i].min_width == 0 &&
						const_var.conditionArrForLeanCompare["left"][i].min_height <= newParams.lean_p_h &&
						const_var.conditionArrForLeanCompare["left"][i].max_height >= newParams.lean_p_h
					) {
						if (left_lean != undefined && const_var.conditionArrForLeanCompare["left"][i].legs_type == left_lean.legstype) {
							newParams.lean_p_e_l = true;
							const_var.compareLeanLegs.leftLean.leanHasDoublelegdisable = true;
							const_var.compareLeanLegs.leftLean.leanHasDoublelegshow = true;
							const_var.compareLeanLegs.leftLean.leanHasDoublelegName = const_var.conditionArrForLeanCompare["left"][i].name;
							const_var.compareLeanLegs.leftLean.leanLegstype =
								const_var.conditionArrForLeanCompare["left"][i].legs_type == "reinforced" ? "double" : const_var.conditionArrForLeanCompare["left"][i].legs_type;
							break;
						} else {
							if (const_var.conditionArrForLeanCompare["left"][i].is_default == "Y") {
								newParams.lean_p_e_l = true;
								const_var.compareLeanLegs.leftLean.leanHasDoublelegdisable = true;
								const_var.compareLeanLegs.leftLean.leanHasDoublelegshow = true;
								const_var.compareLeanLegs.leftLean.leanHasDoublelegName = const_var.conditionArrForLeanCompare["left"][i].name;
							} else {
								newParams.lean_p_e_l = newParams.lean_p_e_l;
								const_var.compareLeanLegs.leftLean.leanHasDoublelegdisable = false;
								const_var.compareLeanLegs.leftLean.leanHasDoublelegshow = true;
								const_var.compareLeanLegs.leftLean.leanHasDoublelegName = const_var.conditionArrForLeanCompare["left"][i].name;
							}
							const_var.compareLeanLegs.leftLean.leanLegstype =
								const_var.conditionArrForLeanCompare["left"][i].legs_type == "reinforced" ? "double" : const_var.conditionArrForLeanCompare["left"][i].legs_type;
						}
					} else if (
						const_var.conditionArrForLeanCompare["left"][i].min_height == 0 &&
						const_var.conditionArrForLeanCompare["left"][i].min_width <= newParams.lean_p_w &&
						const_var.conditionArrForLeanCompare["left"][i].max_width >= newParams.lean_p_w
					) {
						if (left_lean != undefined && const_var.conditionArrForLeanCompare["left"][i].legs_type == left_lean.legstype) {
							newParams.lean_p_e_l = true;
							const_var.compareLeanLegs.leftLean.leanHasDoublelegdisable = true;
							const_var.compareLeanLegs.leftLean.leanHasDoublelegshow = true;
							const_var.compareLeanLegs.leftLean.leanHasDoublelegName = const_var.conditionArrForLeanCompare["left"][i].name;
							const_var.compareLeanLegs.leftLean.leanLegstype =
								const_var.conditionArrForLeanCompare["left"][i].legs_type == "reinforced" ? "double" : const_var.conditionArrForLeanCompare["left"][i].legs_type;
							break;
						} else {
							if (const_var.conditionArrForLeanCompare["left"][i].is_default == "Y") {
								newParams.lean_p_e_l = true;
								const_var.compareLeanLegs.leftLean.leanHasDoublelegdisable = true;
								const_var.compareLeanLegs.leftLean.leanHasDoublelegshow = true;
								const_var.compareLeanLegs.leftLean.leanHasDoublelegName = const_var.conditionArrForLeanCompare["left"][i].name;
							} else {
								newParams.lean_p_e_l = newParams.lean_p_e_l && const_var.crmSetting.is_Edit ? newParams.lean_p_e_l : false;
								newParams.lean_p_e_l = newParams.lean_p_e_l;
								const_var.compareLeanLegs.leftLean.leanHasDoublelegdisable = false;
								const_var.compareLeanLegs.leftLean.leanHasDoublelegshow = true;
								const_var.compareLeanLegs.leftLean.leanHasDoublelegName = const_var.conditionArrForLeanCompare["left"][i].name;
							}
							const_var.compareLeanLegs.leftLean.leanLegstype =
								const_var.conditionArrForLeanCompare["left"][i].legs_type == "reinforced" ? "double" : const_var.conditionArrForLeanCompare["left"][i].legs_type;
						}
					} else {
						j = j + 1;
						if (j == const_var.conditionArrForLeanCompare["left"].length) {
							newParams.lean_p_e_l = false;
							const_var.compareLeanLegs.leftLean.leanHasDoublelegdisable = false;
							const_var.compareLeanLegs.leftLean.leanHasDoublelegshow = false;
							const_var.compareLeanLegs.leftLean.leanHasDoublelegName = "";
							const_var.compareLeanLegs.leftLean.leanLegstype = "single";
						}
					}
				}
			} else {
				newParams.lean_p_e_l = false;
				const_var.compareLeanLegs.leftLean.leanHasDoublelegdisable = false;
				const_var.compareLeanLegs.leftLean.leanHasDoublelegshow = false;
				const_var.compareLeanLegs.leftLean.leanHasDoublelegName = "";
				const_var.compareLeanLegs.leftLean.leanLegstype = "single";
			}
		} else if (type == "rightLean") {
			let j = 0;
			let right_lean = const_var.post_data["building"].leanto.find((s) => s.leanto_type == 2);
			if (const_var.conditionArrForLeanCompare["right"] != undefined && const_var.conditionArrForLeanCompare["right"].length > 0) {
				for (var i = 0; i <= const_var.conditionArrForLeanCompare["right"].length - 1; i++) {
					const_var.conditionArrForLeanCompare["right"][i].min_width =
						const_var.conditionArrForLeanCompare["right"][i].min_width == "" || const_var.conditionArrForLeanCompare["right"][i].min_width == null
							? 0
							: const_var.conditionArrForLeanCompare["right"][i].min_width;
					const_var.conditionArrForLeanCompare["right"][i].min_height =
						const_var.conditionArrForLeanCompare["right"][i].min_height == "" || const_var.conditionArrForLeanCompare["right"][i].min_height == null
							? 0
							: const_var.conditionArrForLeanCompare["right"][i].min_height;
					if (
						const_var.conditionArrForLeanCompare["right"][i].min_width == 0 &&
						const_var.conditionArrForLeanCompare["right"][i].min_height <= newParams.leanR_p_h &&
						const_var.conditionArrForLeanCompare["right"][i].max_height >= newParams.leanR_p_h
					) {
						if (right_lean != undefined && const_var.conditionArrForLeanCompare["right"][i].legs_type == right_lean.legstype) {
							newParams.leanR_p_e_l = true;
							const_var.compareLeanLegs.rightLean.leanRHasDoublelegdisable = true;
							const_var.compareLeanLegs.rightLean.leanRHasDoublelegshow = true;
							const_var.compareLeanLegs.rightLean.leanRHasDoublelegName = const_var.conditionArrForLeanCompare["right"][i].name;
							const_var.compareLeanLegs.rightLean.leanRLegstype =
								const_var.conditionArrForLeanCompare["right"][i].legs_type == "reinforced" ? "double" : const_var.conditionArrForLeanCompare["right"][i].legs_type;
							break;
						} else {
							if (const_var.conditionArrForLeanCompare["right"][i].is_default == "Y") {
								newParams.leanR_p_e_l = true;
								const_var.compareLeanLegs.rightLean.leanRHasDoublelegdisable = true;
								const_var.compareLeanLegs.rightLean.leanRHasDoublelegshow = true;
								const_var.compareLeanLegs.rightLean.leanRHasDoublelegName = const_var.conditionArrForLeanCompare["right"][i].name;
							} else {
								newParams.leanR_p_e_l = newParams.leanR_p_e_l;
								const_var.compareLeanLegs.rightLean.leanRHasDoublelegdisable = false;
								const_var.compareLeanLegs.rightLean.leanRHasDoublelegshow = true;
								const_var.compareLeanLegs.rightLean.leanRHasDoublelegName = const_var.conditionArrForLeanCompare["right"][i].name;
								const_var.conditionArrForLeanCompare["right"][i].checked =
									newParams.leanR_p_e_l && const_var.leanRLegstype != undefined && const_var.leanRLegstype == const_var.conditionArrForLeanCompare["right"][i].legs_type ? true : false;
							}
							const_var.compareLeanLegs.rightLean.leanRLegstype =
								const_var.conditionArrForLeanCompare["right"][i].legs_type == "reinforced" ? "double" : const_var.conditionArrForLeanCompare["right"][i].legs_type;
						}
					} else if (
						const_var.conditionArrForLeanCompare["right"][i].min_height == 0 &&
						const_var.conditionArrForLeanCompare["right"][i].min_width <= newParams.leanR_p_w &&
						const_var.conditionArrForLeanCompare["right"][i].max_width >= newParams.leanR_p_w
					) {
						if (right_lean != undefined && const_var.conditionArrForLeanCompare["right"][i].legs_type == right_lean.legstype) {
							newParams.leanR_p_e_l = true;
							const_var.compareLeanLegs.rightLean.leanRHasDoublelegdisable = true;
							const_var.compareLeanLegs.rightLean.leanRHasDoublelegshow = true;
							const_var.compareLeanLegs.rightLean.leanRHasDoublelegName = const_var.conditionArrForLeanCompare["right"][i].name;
							const_var.compareLeanLegs.rightLean.leanRLegstype =
								const_var.conditionArrForLeanCompare["right"][i].legs_type == "reinforced" ? "double" : const_var.conditionArrForLeanCompare["right"][i].legs_type;
							break;
						} else {
							if (const_var.conditionArrForLeanCompare["right"][i].is_default == "Y") {
								newParams.leanR_p_e_l = true;
								const_var.compareLeanLegs.rightLean.leanRHasDoublelegdisable = true;
								const_var.compareLeanLegs.rightLean.leanRHasDoublelegshow = true;
								const_var.compareLeanLegs.rightLean.leanRHasDoublelegName = const_var.conditionArrForLeanCompare["right"][i].name;
							} else {
								newParams.leanR_p_e_l = newParams.leanR_p_e_l;
								const_var.compareLeanLegs.rightLean.leanRHasDoublelegdisable = false;
								const_var.compareLeanLegs.rightLean.leanRHasDoublelegshow = true;
								const_var.compareLeanLegs.rightLean.leanRHasDoublelegName = const_var.conditionArrForLeanCompare["right"][i].name;
								const_var.conditionArrForLeanCompare["right"][i].checked =
									newParams.leanR_p_e_l && const_var.leanRLegstype != undefined && const_var.leanRLegstype == const_var.conditionArrForLeanCompare["right"][i].legs_type ? true : false;
							}
							const_var.compareLeanLegs.rightLean.leanRLegstype =
								const_var.conditionArrForLeanCompare["right"][i].legs_type == "reinforced" ? "double" : const_var.conditionArrForLeanCompare["right"][i].legs_type;
						}
					} else {
						j = j + 1;

						if (j == const_var.conditionArrForLeanCompare["right"].length) {
							newParams.leanR_p_e_l = false;
							const_var.compareLeanLegs.rightLean.leanRHasDoublelegdisable = false;
							const_var.compareLeanLegs.rightLean.leanRHasDoublelegshow = false;
							const_var.compareLeanLegs.rightLean.leanRHasDoublelegName = "";
							const_var.compareLeanLegs.rightLean.leanRLegstype = "single";
						}
					}
				}
			} else {
				newParams.leanR_p_e_l = false;
				const_var.compareLeanLegs.rightLean.leanRHasDoublelegdisable = false;
				const_var.compareLeanLegs.rightLean.leanRHasDoublelegshow = false;
				const_var.compareLeanLegs.rightLean.leanRHasDoublelegName = "";
				const_var.compareLeanLegs.rightLean.leanRLegstype = "single";
			}
		} else if (type == "frontLean") {
			let j = 0;
			let front_lean = const_var.post_data["building"].leanto.find((s) => s.leanto_type == 3);
			if (const_var.conditionArrForLeanCompare["front"] != undefined && const_var.conditionArrForLeanCompare["front"].length > 0) {
				for (var i = 0; i <= const_var.conditionArrForLeanCompare["front"].length - 1; i++) {
					const_var.conditionArrForLeanCompare["front"][i].min_width =
						const_var.conditionArrForLeanCompare["front"][i].min_width == "" || const_var.conditionArrForLeanCompare["front"][i].min_width == null
							? 0
							: const_var.conditionArrForLeanCompare["front"][i].min_width;
					const_var.conditionArrForLeanCompare["front"][i].min_height =
						const_var.conditionArrForLeanCompare["front"][i].min_height == "" || const_var.conditionArrForLeanCompare["front"][i].min_height == null
							? 0
							: const_var.conditionArrForLeanCompare["front"][i].min_height;
					if (
						const_var.conditionArrForLeanCompare["front"][i].min_width == 0 &&
						const_var.conditionArrForLeanCompare["front"][i].min_height <= newParams.leanF_p_h &&
						const_var.conditionArrForLeanCompare["front"][i].max_height >= newParams.leanF_p_h
					) {
						if (front_lean != undefined && const_var.conditionArrForLeanCompare["front"][i].legs_type == front_lean.legstype) {
							newParams.leanF_p_e_l = true;
							const_var.compareLeanLegs.frontLean.leanFHasDoublelegdisable = true;
							const_var.compareLeanLegs.frontLean.leanFHasDoublelegshow = true;
							const_var.compareLeanLegs.frontLean.leanFHasDoublelegName = const_var.conditionArrForLeanCompare["front"][i].name;
							const_var.compareLeanLegs.frontLean.leanFLegstype =
								const_var.conditionArrForLeanCompare["front"][i].legs_type == "reinforced" ? "double" : const_var.conditionArrForLeanCompare["front"][i].legs_type;
							break;
						} else {
							if (const_var.conditionArrForLeanCompare["front"][i].is_default == "Y") {
								newParams.leanF_p_e_l = true;
								const_var.compareLeanLegs.frontLean.leanFHasDoublelegdisable = true;
								const_var.compareLeanLegs.frontLean.leanFHasDoublelegshow = true;
								const_var.compareLeanLegs.frontLean.leanFHasDoublelegName = const_var.conditionArrForLeanCompare["front"][i].name;
							} else {
								newParams.leanF_p_e_l = newParams.leanF_p_e_l;
								const_var.compareLeanLegs.frontLean.leanFHasDoublelegdisable = false;
								const_var.compareLeanLegs.frontLean.leanFHasDoublelegshow = true;
								const_var.compareLeanLegs.frontLean.leanFHasDoublelegName = const_var.conditionArrForLeanCompare["front"][i].name;
							}
							const_var.compareLeanLegs.frontLean.leanFLegstype =
								const_var.conditionArrForLeanCompare["front"][i].legs_type == "reinforced" ? "double" : const_var.conditionArrForLeanCompare["front"][i].legs_type;
						}
					} else if (
						const_var.conditionArrForLeanCompare["front"][i].min_height == 0 &&
						const_var.conditionArrForLeanCompare["front"][i].min_width <= newParams.leanF_p_w &&
						const_var.conditionArrForLeanCompare["front"][i].max_width >= newParams.leanF_p_w
					) {
						if (front_lean != undefined && const_var.conditionArrForLeanCompare["front"][i].legs_type == front_lean.legstype) {
							newParams.leanF_p_e_l = true;
							const_var.compareLeanLegs.frontLean.leanFHasDoublelegdisable = true;
							const_var.compareLeanLegs.frontLean.leanFHasDoublelegshow = true;
							const_var.compareLeanLegs.frontLean.leanFHasDoublelegName = const_var.conditionArrForLeanCompare["front"][i].name;
							const_var.compareLeanLegs.frontLean.leanFLegstype =
								const_var.conditionArrForLeanCompare["front"][i].legs_type == "reinforced" ? "double" : const_var.conditionArrForLeanCompare["front"][i].legs_type;
							break;
						} else {
							if (const_var.conditionArrForLeanCompare["front"][i].is_default == "Y") {
								newParams.leanF_p_e_l = true;
								const_var.compareLeanLegs.frontLean.leanFHasDoublelegdisable = true;
								const_var.compareLeanLegs.frontLean.leanFHasDoublelegshow = true;
								const_var.compareLeanLegs.frontLean.leanFHasDoublelegName = const_var.conditionArrForLeanCompare["front"][i].name;
								const_var.conditionArrForLeanCompare["front"][i].checked =
									const_var.leanFLegstype != undefined && const_var.leanFLegstype == const_var.conditionArrForLeanCompare["front"][i].legs_type ? true : false;
							} else {
								newParams.leanF_p_e_l = newParams.leanF_p_e_l;
								const_var.compareLeanLegs.frontLean.leanFHasDoublelegdisable = false;
								const_var.compareLeanLegs.frontLean.leanFHasDoublelegshow = true;
								const_var.compareLeanLegs.frontLean.leanFHasDoublelegName = const_var.conditionArrForLeanCompare["front"][i].name;
							}
							const_var.compareLeanLegs.frontLean.leanFLegstype =
								const_var.conditionArrForLeanCompare["front"][i].legs_type == "reinforced" ? "double" : const_var.conditionArrForLeanCompare["front"][i].legs_type;
						}
					} else {
						j = j + 1;

						if (j == const_var.conditionArrForLeanCompare["front"].length) {
							newParams.leanF_p_e_l = false;
							const_var.compareLeanLegs.frontLean.leanFHasDoublelegdisable = false;
							const_var.compareLeanLegs.frontLean.leanFHasDoublelegshow = false;
							const_var.compareLeanLegs.frontLean.leanFHasDoublelegName = "";
							const_var.compareLeanLegs.frontLean.leanFLegstype = "single";
						}
					}
				}
			} else {
				newParams.leanF_p_e_l = false;
				const_var.compareLeanLegs.frontLean.leanFHasDoublelegdisable = false;
				const_var.compareLeanLegs.frontLean.leanFHasDoublelegshow = false;
				const_var.compareLeanLegs.frontLean.leanFHasDoublelegName = "";
				const_var.compareLeanLegs.frontLean.leanFLegstype = "single";
			}
		} else if (type == "backLean") {
			let j = 0;
			let back_lean = const_var.post_data["building"].leanto.find((s) => s.leanto_type == 4);
			if (const_var.conditionArrForLeanCompare["back"] != undefined && const_var.conditionArrForLeanCompare["back"].length > 0) {
				for (var i = 0; i <= const_var.conditionArrForLeanCompare["back"].length - 1; i++) {
					const_var.conditionArrForLeanCompare["back"][i].min_width =
						const_var.conditionArrForLeanCompare["back"][i].min_width == "" || const_var.conditionArrForLeanCompare["back"][i].min_width == null
							? 0
							: const_var.conditionArrForLeanCompare["back"][i].min_width;
					const_var.conditionArrForLeanCompare["back"][i].min_height =
						const_var.conditionArrForLeanCompare["back"][i].min_height == "" || const_var.conditionArrForLeanCompare["back"][i].min_height == null
							? 0
							: const_var.conditionArrForLeanCompare["back"][i].min_height;
					if (
						const_var.conditionArrForLeanCompare["back"][i].min_width == 0 &&
						const_var.conditionArrForLeanCompare["back"][i].min_height <= newParams.leanB_p_h &&
						const_var.conditionArrForLeanCompare["back"][i].max_height >= newParams.leanB_p_h
					) {
						if (back_lean != undefined && const_var.conditionArrForLeanCompare["back"][i].legs_type == back_lean.legstype) {
							newParams.leanB_p_e_l = true;
							const_var.compareLeanLegs.backLean.leanBHasDoublelegdisable = true;
							const_var.compareLeanLegs.backLean.leanBHasDoublelegshow = true;
							const_var.compareLeanLegs.backLean.leanBHasDoublelegName = const_var.conditionArrForLeanCompare["back"][i].name;
							const_var.compareLeanLegs.backLean.leanBLegstype =
								const_var.conditionArrForLeanCompare["back"][i].legs_type == "reinforced" ? "double" : const_var.conditionArrForLeanCompare["back"][i].legs_type;
							break;
						} else {
							if (const_var.conditionArrForLeanCompare["back"][i].is_default == "Y") {
								newParams.leanB_p_e_l = true;
								const_var.compareLeanLegs.backLean.leanBHasDoublelegdisable = true;
								const_var.compareLeanLegs.backLean.leanBHasDoublelegshow = true;
								const_var.compareLeanLegs.backLean.leanBHasDoublelegName = const_var.conditionArrForLeanCompare["back"][i].name;
							} else {
								newParams.leanB_p_e_l = newParams.leanB_p_e_l;
								const_var.compareLeanLegs.backLean.leanBHasDoublelegdisable = false;
								const_var.compareLeanLegs.backLean.leanBHasDoublelegshow = true;
								const_var.compareLeanLegs.backLean.leanBHasDoublelegName = const_var.conditionArrForLeanCompare["back"][i].name;
							}
							const_var.compareLeanLegs.backLean.leanBLegstype =
								const_var.conditionArrForLeanCompare["back"][i].legs_type == "reinforced" ? "double" : const_var.conditionArrForLeanCompare["back"][i].legs_type;
						}
					} else if (
						const_var.conditionArrForLeanCompare["back"][i].min_height == 0 &&
						const_var.conditionArrForLeanCompare["back"][i].min_width <= newParams.leanB_p_w &&
						const_var.conditionArrForLeanCompare["back"][i].max_width >= newParams.leanB_p_w
					) {
						if (back_lean != undefined && const_var.conditionArrForLeanCompare["back"][i].legs_type == back_lean.legstype) {
							newParams.leanB_p_e_l = true;
							const_var.compareLeanLegs.backLean.leanBHasDoublelegdisable = true;
							const_var.compareLeanLegs.backLean.leanBHasDoublelegshow = true;
							const_var.compareLeanLegs.backLean.leanBHasDoublelegName = const_var.conditionArrForLeanCompare["back"][i].name;
							const_var.compareLeanLegs.backLean.leanBLegstype =
								const_var.conditionArrForLeanCompare["back"][i].legs_type == "reinforced" ? "double" : const_var.conditionArrForLeanCompare["back"][i].legs_type;
							break;
						} else {
							if (const_var.conditionArrForLeanCompare["back"][i].is_default == "Y") {
								newParams.leanB_p_e_l = true;
								const_var.compareLeanLegs.backLean.leanBHasDoublelegdisable = true;
								const_var.compareLeanLegs.backLean.leanBHasDoublelegshow = true;
								const_var.compareLeanLegs.backLean.leanBHasDoublelegName = const_var.conditionArrForLeanCompare["back"][i].name;
							} else {
								newParams.leanB_p_e_l = newParams.leanB_p_e_l;
								const_var.compareLeanLegs.backLean.leanBHasDoublelegdisable = false;
								const_var.compareLeanLegs.backLean.leanBHasDoublelegshow = true;
								const_var.compareLeanLegs.backLean.leanBHasDoublelegName = const_var.conditionArrForLeanCompare["back"][i].name;
							}
							const_var.compareLeanLegs.backLean.leanBLegstype =
								const_var.conditionArrForLeanCompare["back"][i].legs_type == "reinforced" ? "double" : const_var.conditionArrForLeanCompare["back"][i].legs_type;
						}
					} else {
						j = j + 1;

						if (j == const_var.conditionArrForLeanCompare["back"].length) {
							newParams.leanB_p_e_l = false;
							const_var.compareLeanLegs.backLean.leanBHasDoublelegdisable = false;
							const_var.compareLeanLegs.backLean.leanBHasDoublelegshow = false;
							const_var.compareLeanLegs.backLean.leanBHasDoublelegName = "";
							const_var.compareLeanLegs.backLean.leanBLegstype = "single";
						}
					}
				}
			} else {
				newParams.leanB_p_e_l = false;
				const_var.compareLeanLegs.backLean.leanBHasDoublelegdisable = false;
				const_var.compareLeanLegs.backLean.leanBHasDoublelegshow = false;
				const_var.compareLeanLegs.backLean.leanBHasDoublelegName = "";
				const_var.compareLeanLegs.backLean.leanBLegstype = "single";
			}
		}
	};

	const CheckLegsByResponseForCompare = (newParams) => {
		var j = 0;

		if (const_var.ConditionArrCompare[newParams.p_b_t].length > 0 && const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s] != undefined) {
			for (var i = 0; i <= const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s].length - 1; i++) {
				const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s][i].min_width =
					const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s][i].min_width == "" || const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s][i].min_width == null
						? 0
						: const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s][i].min_width;
				const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s][i].min_height =
					const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s][i].min_height == "" || const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s][i].min_height == null
						? 0
						: const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s][i].min_height;
				if (
					const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s][i].min_width == 0 &&
					const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s][i].min_height <= newParams.p_h &&
					const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s][i].max_height >= newParams.p_h
				) {
					if (const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s][i].legs_type == const_var.post_data["building"].legstype) {
						newParams.p_e_l = true;
						newParams.hasDoublelegName = const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s][i].name;
						newParams.legstype =
							const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s][i].legs_type == "reinforced" ? "double" : const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s][i].legs_type;
						break;
					} else {
						if (const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s][i].is_default == "Y") {
							newParams.p_e_l = true;
						} else {
							newParams.p_e_l = newParams.p_e_l;
						}
						newParams.hasDoublelegName = const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s][i].name;
						newParams.legstype =
							const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s][i].legs_type == "reinforced" ? "double" : const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s][i].legs_type;
					}
				} else if (
					const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s][i].min_height == 0 &&
					const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s][i].min_width <= newParams.p_w &&
					const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s][i].max_width >= newParams.p_w
				) {
					if (const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s][i].legs_type == const_var.post_data["building"].legstype) {
						newParams.p_e_l = true;
						newParams.hasDoublelegName = const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s][i].name;
						newParams.legstype =
							const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s][i].legs_type == "reinforced" ? "double" : const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s][i].legs_type;
						break;
					} else {
						if (const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s][i].is_default == "Y") {
							newParams.p_e_l = true;
						} else {
							newParams.p_e_l = newParams.p_e_l;
						}
						newParams.hasDoublelegName = const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s][i].name;
						newParams.legstype =
							const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s][i].legs_type == "reinforced" ? "double" : const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s][i].legs_type;
					}
				} else {
					j = j + 1;

					if (j == const_var.ConditionArrCompare[newParams.p_b_t][newParams.p_r_s].length) {
						newParams.hasDoublelegName = "";
						newParams.p_e_l = false;
						newParams.legstype = "single";
					}
				}
			}
		} else {
			newParams.p_e_l = false;
			newParams.hasDoublelegName = "";
			newParams.legstype = "single";
		}
		newParams.p_e_l = newParams.p_e_l;
		newParams.legstype = newParams.legstype;
	};

	const CheckLegsByResponse = (state) => {
		const { BuildingUpdate } = getRuntimeDeps();
		var j = 0;
		let countWidth = 0;
		let countHeight = 0;
		if (const_var.ConditionArr[params.p_b_t].length > 0 && const_var.ConditionArr[params.p_b_t][params.p_r_s] != undefined) {
			const_var.ConditionArr[params.p_b_t][params.p_r_s].CustomArray = [];
			countWidth = const_var.ConditionArr[params.p_b_t][params.p_r_s].filter((data) => (data.min_width != "" || data.min_width != null) && data.min_width <= params.p_w && data.max_width >= params.p_w);
			countHeight = const_var.ConditionArr[params.p_b_t][params.p_r_s].filter((data) => (data.min_height != "" || data.min_height != null) && data.min_height <= params.p_h && data.max_height >= params.p_h);
			const_var.ConditionArr[params.p_b_t][params.p_r_s].CustomArray = countHeight.length > 0 ? countHeight : countWidth;

			for (var i = 0; i <= const_var.ConditionArr[params.p_b_t][params.p_r_s].length - 1; i++) {
				const_var.ConditionArr[params.p_b_t][params.p_r_s][i].min_width =
					const_var.ConditionArr[params.p_b_t][params.p_r_s][i].min_width == "" || const_var.ConditionArr[params.p_b_t][params.p_r_s][i].min_width == null
						? 0
						: const_var.ConditionArr[params.p_b_t][params.p_r_s][i].min_width;
				const_var.ConditionArr[params.p_b_t][params.p_r_s][i].min_height =
					const_var.ConditionArr[params.p_b_t][params.p_r_s][i].min_height == "" || const_var.ConditionArr[params.p_b_t][params.p_r_s][i].min_height == null
						? 0
						: const_var.ConditionArr[params.p_b_t][params.p_r_s][i].min_height;
				if (
					const_var.ConditionArr[params.p_b_t][params.p_r_s][i].min_width == 0 &&
					const_var.ConditionArr[params.p_b_t][params.p_r_s][i].min_height <= params.p_h &&
					const_var.ConditionArr[params.p_b_t][params.p_r_s][i].max_height >= params.p_h
				) {
					if (const_var.ConditionArr[params.p_b_t][params.p_r_s][i].is_default == "Y") {
						params.p_e_l = true;
						const_var.hasDoublelegdisable = true;
						const_var.hasDoublelegshow = true;

						const_var.ConditionArr[params.p_b_t][params.p_r_s][i].checked = const_var.crmSetting.is_Edit
							? const_var.legstype != undefined && const_var.legstype == const_var.ConditionArr[params.p_b_t][params.p_r_s][i].legs_type
								? true
								: false
							: true;
					} else {
						params.p_e_l = params.p_e_l ? params.p_e_l : false;
						const_var.hasDoublelegdisable = false;
						const_var.hasDoublelegshow = true;

						const_var.ConditionArr[params.p_b_t][params.p_r_s][i].checked =
							params.p_e_l && const_var.legstype != undefined && const_var.legstype == const_var.ConditionArr[params.p_b_t][params.p_r_s][i].legs_type ? true : false;
					}
					if (const_var.crmSetting.is_Edit && const_var.ConditionArr[params.p_b_t][params.p_r_s][i].checked != undefined && const_var.ConditionArr[params.p_b_t][params.p_r_s][i].checked) {
						const_var.legstype = const_var.ConditionArr[params.p_b_t][params.p_r_s][i].legs_type == "reinforced" ? "double" : const_var.ConditionArr[params.p_b_t][params.p_r_s][i].legs_type.toLowerCase();
						const_var.hasDoublelegName = const_var.ConditionArr[params.p_b_t][params.p_r_s][i].name;
					}
				} else if (
					const_var.ConditionArr[params.p_b_t][params.p_r_s][i].min_height == 0 &&
					const_var.ConditionArr[params.p_b_t][params.p_r_s][i].min_width <= params.p_w &&
					const_var.ConditionArr[params.p_b_t][params.p_r_s][i].max_width >= params.p_w
				) {
					if (const_var.ConditionArr[params.p_b_t][params.p_r_s][i].is_default == "Y") {
						params.p_e_l = true;
						const_var.hasDoublelegdisable = true;
						const_var.hasDoublelegshow = true;

						const_var.ConditionArr[params.p_b_t][params.p_r_s][i].checked = const_var.crmSetting.is_Edit
							? const_var.legstype != undefined && const_var.legstype == const_var.ConditionArr[params.p_b_t][params.p_r_s][i].legs_type
								? true
								: false
							: true;
					} else {
						params.p_e_l = params.p_e_l ? params.p_e_l : false;
						const_var.hasDoublelegdisable = false;
						const_var.hasDoublelegshow = true;

						const_var.ConditionArr[params.p_b_t][params.p_r_s][i].checked =
							params.p_e_l && const_var.legstype != undefined && const_var.legstype == const_var.ConditionArr[params.p_b_t][params.p_r_s][i].legs_type ? true : false;
					}
					if (const_var.crmSetting.is_Edit && const_var.ConditionArr[params.p_b_t][params.p_r_s][i].checked != undefined && const_var.ConditionArr[params.p_b_t][params.p_r_s][i].checked) {
						const_var.legstype = const_var.ConditionArr[params.p_b_t][params.p_r_s][i].legs_type == "reinforced" ? "double" : const_var.ConditionArr[params.p_b_t][params.p_r_s][i].legs_type.toLowerCase();
						const_var.hasDoublelegName = const_var.ConditionArr[params.p_b_t][params.p_r_s][i].name;
					}
				} else {
					j = j + 1;

					if (j == const_var.ConditionArr[params.p_b_t][params.p_r_s].length) {
						params.p_e_l = false;
						const_var.hasDoublelegdisable = false;
						const_var.hasDoublelegshow = false;
						const_var.hasDoublelegName = "";
						const_var.legstype = "single";
					}
				}
			}
		} else {
			params.p_e_l = false;
			const_var.hasDoublelegdisable = false;
			const_var.hasDoublelegshow = false;
			const_var.hasDoublelegName = "";

			const_var.legstype = "single";
		}
		params.p_e_l = state.defalutProductLoad == true && const_var.defaultProData.building.has_double_leg == true && const_var.CallApionAction == false ? true : params.p_e_l;
		const_var.legstype =
			state.defalutProductLoad == true && const_var.defaultProData.building.legstype != undefined && const_var.CallApionAction == false ? const_var.defaultProData.building.legstype : const_var.legstype;

		BuildingUpdate(true, "");
	};

	const CheckLeanLegsByResponse = (state, type) => {
		if (params.add_left_lean && (type == "addLeftLean" || type == "all")) {
			var j = 0;

			let countLLWidth = 0;
			let countLLHeight = 0;
			if (const_var.ConditionArrForLean["left"] != undefined && const_var.ConditionArrForLean["left"].length > 0) {
				const_var.ConditionArrForLean["left"].CustomArray = [];
				countLLWidth = const_var.ConditionArrForLean["left"].filter((data) => (data.min_width != "" || data.min_width != null) && data.min_width <= params.lean_p_w && data.max_width >= params.lean_p_w);
				countLLHeight = const_var.ConditionArrForLean["left"].filter((data) => (data.min_height != "" || data.min_height != null) && data.min_height <= params.lean_p_h && data.max_height >= params.lean_p_h);
				const_var.ConditionArrForLean["left"].CustomArray = countLLHeight.length > 0 ? countLLHeight : countLLWidth;

				for (var i = 0; i <= const_var.ConditionArrForLean["left"].length - 1; i++) {
					const_var.ConditionArrForLean["left"][i].min_width =
						const_var.ConditionArrForLean["left"][i].min_width == "" || const_var.ConditionArrForLean["left"][i].min_width == null ? 0 : const_var.ConditionArrForLean["left"][i].min_width;
					const_var.ConditionArrForLean["left"][i].min_height =
						const_var.ConditionArrForLean["left"][i].min_height == "" || const_var.ConditionArrForLean["left"][i].min_height == null ? 0 : const_var.ConditionArrForLean["left"][i].min_height;
					if (
						const_var.ConditionArrForLean["left"][i].min_width == 0 &&
						const_var.ConditionArrForLean["left"][i].min_height <= params.lean_p_h &&
						const_var.ConditionArrForLean["left"][i].max_height >= params.lean_p_h
					) {
						if (const_var.ConditionArrForLean["left"][i].is_default == "Y") {
							params.lean_p_e_l = true;
							const_var.leanHasDoublelegdisable = true;
							const_var.leanHasDoublelegshow = true;

							const_var.ConditionArrForLean["left"][i].checked = const_var.crmSetting.is_Edit
								? const_var.leanLegstype != undefined && const_var.leanLegstype == const_var.ConditionArrForLean["left"][i].legs_type
									? true
									: false
								: true;
						} else {
							params.lean_p_e_l = params.lean_p_e_l ? params.lean_p_e_l : false;
							const_var.leanHasDoublelegdisable = false;
							const_var.leanHasDoublelegshow = true;

							const_var.ConditionArrForLean["left"][i].checked =
								params.lean_p_e_l && const_var.leanLegstype != undefined && const_var.leanLegstype == const_var.ConditionArrForLean["left"][i].legs_type ? true : false;
						}
						if (const_var.crmSetting.is_Edit && const_var.ConditionArrForLean["left"][i].checked != undefined && const_var.ConditionArrForLean["left"][i].checked) {
							const_var.leanLegstype = const_var.ConditionArrForLean["left"][i].legs_type == "reinforced" ? "double" : const_var.ConditionArrForLean["left"][i].legs_type;
							const_var.leanHasDoublelegName = const_var.ConditionArrForLean["left"][i].name;
						}
						const_var.reinforcedtype["left"] = const_var.ConditionArrForLean["left"][i].legs_type == "reinforced" ? "reinforced" : const_var.ConditionArrForLean["left"][i].legs_type;
					} else if (
						const_var.ConditionArrForLean["left"][i].min_height == 0 &&
						const_var.ConditionArrForLean["left"][i].min_width <= params.lean_p_w &&
						const_var.ConditionArrForLean["left"][i].max_width >= params.lean_p_w
					) {
						if (const_var.ConditionArrForLean["left"][i].is_default == "Y") {
							params.lean_p_e_l = true;
							const_var.leanHasDoublelegdisable = true;
							const_var.leanHasDoublelegshow = true;

							const_var.ConditionArrForLean["left"][i].checked = const_var.crmSetting.is_Edit
								? const_var.leanLegstype != undefined && const_var.leanLegstype == const_var.ConditionArrForLean["left"][i].legs_type
									? true
									: false
								: true;
						} else {
							params.lean_p_e_l = params.lean_p_e_l ? params.lean_p_e_l : false;
							const_var.leanHasDoublelegdisable = false;
							const_var.leanHasDoublelegshow = true;

							const_var.ConditionArrForLean["left"][i].checked =
								params.lean_p_e_l && const_var.leanLegstype != undefined && const_var.leanLegstype == const_var.ConditionArrForLean["left"][i].legs_type ? true : false;
						}
						if (const_var.crmSetting.is_Edit && const_var.ConditionArrForLean["left"][i].checked != undefined && const_var.ConditionArrForLean["left"][i].checked) {
							const_var.leanLegstype = const_var.ConditionArrForLean["left"][i].legs_type == "reinforced" ? "double" : const_var.ConditionArrForLean["left"][i].legs_type;
							const_var.leanHasDoublelegName = const_var.ConditionArrForLean["left"][i].name;
						}
						const_var.reinforcedtype["left"] = const_var.ConditionArrForLean["left"][i].legs_type == "reinforced" ? "reinforced" : const_var.ConditionArrForLean["left"][i].legs_type;
					} else {
						j = j + 1;

						if (j == const_var.ConditionArrForLean["left"].length) {
							params.lean_p_e_l = false;
							const_var.leanHasDoublelegdisable = false;
							const_var.leanHasDoublelegshow = false;
							const_var.leanHasDoublelegName = "";
							const_var.leanLegstype = "single";
						}
					}
				}
			} else {
				params.lean_p_e_l = false;
				const_var.leanHasDoublelegdisable = false;
				const_var.leanHasDoublelegshow = false;
				const_var.leanHasDoublelegName = "";
				const_var.leanLegstype = "single";
			}

			params.lean_p_e_l = state.defalutProductLoad == true && const_var.defaultProData.building.has_double_leg == true && const_var.CallApionAction == false ? true : params.lean_p_e_l;
			const_var.leanLegstype =
				state.defalutProductLoad == true && const_var.defaultProData.building.leanLegstype != undefined && const_var.CallApionAction == false ? const_var.defaultProData.building.legstype : const_var.leanLegstype;
		}
		if (params.add_right_lean && (type == "addRightLean" || type == "all")) {
			var j = 0;

			let countRLWidth = 0;
			let countRLHeight = 0;
			if (const_var.ConditionArrForLean["right"] != undefined && const_var.ConditionArrForLean["right"].length > 0) {
				const_var.ConditionArrForLean["right"].CustomArray = [];
				countRLWidth = const_var.ConditionArrForLean["right"].filter((data) => (data.min_width != "" || data.min_width != null) && data.min_width <= params.leanR_p_w && data.max_width >= params.leanR_p_w);
				countRLHeight = const_var.ConditionArrForLean["right"].filter((data) => (data.min_height != "" || data.min_height != null) && data.min_height <= params.leanR_p_h && data.max_height >= params.leanR_p_h);
				const_var.ConditionArrForLean["right"].CustomArray = countRLHeight.length > 0 ? countRLHeight : countRLWidth;
				for (var i = 0; i <= const_var.ConditionArrForLean["right"].length - 1; i++) {
					const_var.ConditionArrForLean["right"][i].min_width =
						const_var.ConditionArrForLean["right"][i].min_width == "" || const_var.ConditionArrForLean["right"][i].min_width == null ? 0 : const_var.ConditionArrForLean["right"][i].min_width;
					const_var.ConditionArrForLean["right"][i].min_height =
						const_var.ConditionArrForLean["right"][i].min_height == "" || const_var.ConditionArrForLean["right"][i].min_height == null ? 0 : const_var.ConditionArrForLean["right"][i].min_height;
					if (
						const_var.ConditionArrForLean["right"][i].min_width == 0 &&
						const_var.ConditionArrForLean["right"][i].min_height <= params.leanR_p_h &&
						const_var.ConditionArrForLean["right"][i].max_height >= params.leanR_p_h
					) {
						if (const_var.ConditionArrForLean["right"][i].is_default == "Y") {
							params.leanR_p_e_l = true;
							const_var.leanRHasDoublelegdisable = true;
							const_var.leanRHasDoublelegshow = true;

							const_var.ConditionArrForLean["right"][i].checked = const_var.crmSetting.is_Edit
								? const_var.leanRLegstype != undefined && const_var.leanRLegstype == const_var.ConditionArrForLean["right"][i].legs_type
									? true
									: false
								: true;
						} else {
							params.leanR_p_e_l = params.leanR_p_e_l ? params.leanR_p_e_l : false;
							const_var.leanRHasDoublelegdisable = false;
							const_var.leanRHasDoublelegshow = true;

							const_var.ConditionArrForLean["right"][i].checked =
								params.leanR_p_e_l && const_var.leanRLegstype != undefined && const_var.leanRLegstype == const_var.ConditionArrForLean["right"][i].legs_type ? true : false;
						}
						if (const_var.crmSetting.is_Edit && const_var.ConditionArrForLean["right"][i].checked != undefined && const_var.ConditionArrForLean["right"][i].checked) {
							const_var.leanRLegstype = const_var.ConditionArrForLean["right"][i].legs_type == "reinforced" ? "double" : const_var.ConditionArrForLean["right"][i].legs_type;
							const_var.leanRHasDoublelegName = const_var.ConditionArrForLean["right"][i].name;
						}
						const_var.reinforcedtype["right"] = const_var.ConditionArrForLean["right"][i].legs_type == "reinforced" ? "reinforced" : const_var.ConditionArrForLean["right"][i].legs_type;
					} else if (
						const_var.ConditionArrForLean["right"][i].min_height == 0 &&
						const_var.ConditionArrForLean["right"][i].min_width <= params.leanR_p_w &&
						const_var.ConditionArrForLean["right"][i].max_width >= params.leanR_p_w
					) {
						if (const_var.ConditionArrForLean["right"][i].is_default == "Y") {
							params.leanR_p_e_l = true;
							const_var.leanRHasDoublelegdisable = true;
							const_var.leanRHasDoublelegshow = true;

							const_var.ConditionArrForLean["right"][i].checked = const_var.crmSetting.is_Edit
								? const_var.leanRLegstype != undefined && const_var.leanRLegstype == const_var.ConditionArrForLean["right"][i].legs_type
									? true
									: false
								: true;
						} else {
							params.leanR_p_e_l = params.leanR_p_e_l ? params.leanR_p_e_l : false;
							const_var.leanRHasDoublelegdisable = false;
							const_var.leanRHasDoublelegshow = true;

							const_var.ConditionArrForLean["right"][i].checked =
								params.leanR_p_e_l && const_var.leanRLegstype != undefined && const_var.leanRLegstype == const_var.ConditionArrForLean["right"][i].legs_type ? true : false;
						}
						if (const_var.crmSetting.is_Edit && const_var.ConditionArrForLean["right"][i].checked != undefined && const_var.ConditionArrForLean["right"][i].checked) {
							const_var.leanRLegstype = const_var.ConditionArrForLean["right"][i].legs_type == "reinforced" ? "double" : const_var.ConditionArrForLean["right"][i].legs_type;
							const_var.leanRHasDoublelegName = const_var.ConditionArrForLean["right"][i].name;
						}
						const_var.reinforcedtype["right"] = const_var.ConditionArrForLean["right"][i].legs_type == "reinforced" ? "reinforced" : const_var.ConditionArrForLean["right"][i].legs_type;
					} else {
						j = j + 1;

						if (j == const_var.ConditionArrForLean["right"].length) {
							params.leanR_p_e_l = false;
							const_var.leanRHasDoublelegdisable = false;
							const_var.leanRHasDoublelegshow = false;
							const_var.leanRHasDoublelegName = "";
							const_var.leanRLegstype = "single";
						}
					}
				}
			} else {
				params.leanR_p_e_l = false;
				const_var.leanRHasDoublelegdisable = false;
				const_var.leanRHasDoublelegshow = false;
				const_var.leanRHasDoublelegName = "";
				const_var.leanRLegstype = "single";
			}

			params.leanR_p_e_l = state.defalutProductLoad == true && const_var.defaultProData.building.has_double_leg == true && const_var.CallApionAction == false ? true : params.leanR_p_e_l;
			const_var.leanRLegstype =
				state.defalutProductLoad == true && const_var.defaultProData.building.leanRLegstype != undefined && const_var.CallApionAction == false
					? const_var.defaultProData.building.legstype
					: const_var.leanRLegstype;
		}
		if (params.add_front_lean && (type == "addFrontLean" || type == "all")) {
			var j = 0;
			let countFLWidth = 0;
			let countFLHeight = 0;
			if (const_var.ConditionArrForLean["front"] != undefined && const_var.ConditionArrForLean["front"].length > 0) {
				const_var.ConditionArrForLean["front"].CustomArray = [];
				countFLWidth = const_var.ConditionArrForLean["front"].filter((data) => (data.min_width != "" || data.min_width != null) && data.min_width <= params.leanF_p_w && data.max_width >= params.leanF_p_w);
				countFLHeight = const_var.ConditionArrForLean["front"].filter((data) => (data.min_height != "" || data.min_height != null) && data.min_height <= params.leanF_p_h && data.max_height >= params.leanF_p_h);
				const_var.ConditionArrForLean["front"].CustomArray = countFLHeight.length > 0 ? countFLHeight : countFLWidth;
				for (var i = 0; i <= const_var.ConditionArrForLean["front"].length - 1; i++) {
					const_var.ConditionArrForLean["front"][i].min_width =
						const_var.ConditionArrForLean["front"][i].min_width == "" || const_var.ConditionArrForLean["front"][i].min_width == null ? 0 : const_var.ConditionArrForLean["front"][i].min_width;
					const_var.ConditionArrForLean["front"][i].min_height =
						const_var.ConditionArrForLean["front"][i].min_height == "" || const_var.ConditionArrForLean["front"][i].min_height == null ? 0 : const_var.ConditionArrForLean["front"][i].min_height;
					if (
						const_var.ConditionArrForLean["front"][i].min_width == 0 &&
						const_var.ConditionArrForLean["front"][i].min_height <= params.leanF_p_h &&
						const_var.ConditionArrForLean["front"][i].max_height >= params.leanF_p_h
					) {
						if (const_var.ConditionArrForLean["front"][i].is_default == "Y") {
							params.leanF_p_e_l = true;
							const_var.leanFHasDoublelegdisable = true;
							const_var.leanFHasDoublelegshow = true;

							const_var.ConditionArrForLean["front"][i].checked = const_var.crmSetting.is_Edit
								? const_var.leanFLegstype != undefined && const_var.leanFLegstype == const_var.ConditionArrForLean["front"][i].legs_type
									? true
									: false
								: true;
						} else {
							params.leanF_p_e_l = params.leanF_p_e_l ? params.leanF_p_e_l : false;
							const_var.leanFHasDoublelegdisable = false;
							const_var.leanFHasDoublelegshow = true;

							const_var.ConditionArrForLean["front"][i].checked =
								params.leanF_p_e_l && const_var.leanFLegstype != undefined && const_var.leanFLegstype == const_var.ConditionArrForLean["front"][i].legs_type ? true : false;
						}
						if (const_var.crmSetting.is_Edit && const_var.ConditionArrForLean["front"][i].checked != undefined && const_var.ConditionArrForLean["front"][i].checked) {
							const_var.leanFLegstype = const_var.ConditionArrForLean["front"][i].legs_type == "reinforced" ? "double" : const_var.ConditionArrForLean["front"][i].legs_type;
							const_var.leanFHasDoublelegName = const_var.ConditionArrForLean["front"][i].name;
						}
						const_var.reinforcedtype["front"] = const_var.ConditionArrForLean["front"][i].legs_type == "reinforced" ? "reinforced" : const_var.ConditionArrForLean["front"][i].legs_type;
					} else if (
						const_var.ConditionArrForLean["front"][i].min_height == 0 &&
						const_var.ConditionArrForLean["front"][i].min_width <= params.leanF_p_w &&
						const_var.ConditionArrForLean["front"][i].max_width >= params.leanF_p_w
					) {
						if (const_var.ConditionArrForLean["front"][i].is_default == "Y") {
							params.leanF_p_e_l = true;
							const_var.leanFHasDoublelegdisable = true;
							const_var.leanFHasDoublelegshow = true;

							const_var.ConditionArrForLean["front"][i].checked = const_var.crmSetting.is_Edit
								? const_var.leanFLegstype != undefined && const_var.leanFLegstype == const_var.ConditionArrForLean["front"][i].legs_type
									? true
									: false
								: true;
						} else {
							params.leanF_p_e_l = params.leanF_p_e_l ? params.leanF_p_e_l : false;
							const_var.leanFHasDoublelegdisable = false;
							const_var.leanFHasDoublelegshow = true;

							const_var.ConditionArrForLean["front"][i].checked =
								params.leanF_p_e_l && const_var.leanFLegstype != undefined && const_var.leanFLegstype == const_var.ConditionArrForLean["front"][i].legs_type ? true : false;
						}
						if (const_var.crmSetting.is_Edit && const_var.ConditionArrForLean["front"][i].checked != undefined && const_var.ConditionArrForLean["front"][i].checked) {
							const_var.leanFLegstype = const_var.ConditionArrForLean["front"][i].legs_type == "reinforced" ? "double" : const_var.ConditionArrForLean["front"][i].legs_type;
							const_var.leanFHasDoublelegName = const_var.ConditionArrForLean["front"][i].name;
						}
						const_var.reinforcedtype["front"] = const_var.ConditionArrForLean["front"][i].legs_type == "reinforced" ? "reinforced" : const_var.ConditionArrForLean["front"][i].legs_type;
					} else {
						j = j + 1;

						if (j == const_var.ConditionArrForLean["front"].length) {
							params.leanF_p_e_l = false;
							const_var.leanFHasDoublelegdisable = false;
							const_var.leanFHasDoublelegshow = false;
							const_var.leanFHasDoublelegName = "";
							const_var.leanFLegstype = "single";
						}
					}
				}
			} else {
				params.leanF_p_e_l = false;
				const_var.leanFHasDoublelegdisable = false;
				const_var.leanFHasDoublelegshow = false;
				const_var.leanFHasDoublelegName = "";
				const_var.leanFLegstype = "single";
			}

			params.leanF_p_e_l = state.defalutProductLoad == true && const_var.defaultProData.building.has_double_leg == true && const_var.CallApionAction == false ? true : params.leanF_p_e_l;
			const_var.leanFLegstype =
				state.defalutProductLoad == true && const_var.defaultProData.building.leanFLegstype != undefined && const_var.CallApionAction == false
					? const_var.defaultProData.building.legstype
					: const_var.leanFLegstype;
		}
		if (params.add_back_lean && (type == "addBackLean" || type == "all")) {
			var j = 0;
			let countBLWidth = 0;
			let countBLHeight = 0;
			if (const_var.ConditionArrForLean["back"] != undefined && const_var.ConditionArrForLean["back"].length > 0) {
				const_var.ConditionArrForLean["back"].CustomArray = [];
				countBLWidth = const_var.ConditionArrForLean["back"].filter((data) => (data.min_width != "" || data.min_width != null) && data.min_width <= params.leanB_p_w && data.max_width >= params.leanB_p_w);
				countBLHeight = const_var.ConditionArrForLean["back"].filter((data) => (data.min_height != "" || data.min_height != null) && data.min_height <= params.leanB_p_h && data.max_height >= params.leanB_p_h);
				const_var.ConditionArrForLean["back"].CustomArray = countBLHeight.length > 0 ? countBLHeight : countBLWidth;
				for (var i = 0; i <= const_var.ConditionArrForLean["back"].length - 1; i++) {
					const_var.ConditionArrForLean["back"][i].min_width =
						const_var.ConditionArrForLean["back"][i].min_width == "" || const_var.ConditionArrForLean["back"][i].min_width == null ? 0 : const_var.ConditionArrForLean["back"][i].min_width;
					const_var.ConditionArrForLean["back"][i].min_height =
						const_var.ConditionArrForLean["back"][i].min_height == "" || const_var.ConditionArrForLean["back"][i].min_height == null ? 0 : const_var.ConditionArrForLean["back"][i].min_height;
					if (
						const_var.ConditionArrForLean["back"][i].min_width == 0 &&
						const_var.ConditionArrForLean["back"][i].min_height <= params.leanB_p_h &&
						const_var.ConditionArrForLean["back"][i].max_height >= params.leanB_p_h
					) {
						if (const_var.ConditionArrForLean["back"][i].is_default == "Y") {
							params.leanB_p_e_l = true;
							const_var.leanBHasDoublelegdisable = true;
							const_var.leanBHasDoublelegshow = true;

							const_var.ConditionArrForLean["back"][i].checked = const_var.crmSetting.is_Edit
								? const_var.leanBLegstype != undefined && const_var.leanBLegstype == const_var.ConditionArrForLean["back"][i].legs_type
									? true
									: false
								: true;
						} else {
							params.leanB_p_e_l = params.leanB_p_e_l ? params.leanB_p_e_l : false;
							const_var.leanBHasDoublelegdisable = false;
							const_var.leanBHasDoublelegshow = true;

							const_var.ConditionArrForLean["back"][i].checked =
								params.leanB_p_e_l && const_var.leanBLegstype != undefined && const_var.leanBLegstype == const_var.ConditionArrForLean["back"][i].legs_type ? true : false;
						}
						if (const_var.crmSetting.is_Edit && const_var.ConditionArrForLean["back"][i].checked != undefined && const_var.ConditionArrForLean["back"][i].checked) {
							const_var.leanBLegstype = const_var.ConditionArrForLean["back"][i].legs_type == "reinforced" ? "double" : const_var.ConditionArrForLean["back"][i].legs_type;
							const_var.leanBHasDoublelegName = const_var.ConditionArrForLean["back"][i].name;
						}
						const_var.reinforcedtype["back"] = const_var.ConditionArrForLean["back"][i].legs_type == "reinforced" ? "reinforced" : const_var.ConditionArrForLean["back"][i].legs_type;
					} else if (
						const_var.ConditionArrForLean["back"][i].min_height == 0 &&
						const_var.ConditionArrForLean["back"][i].min_width <= params.leanB_p_w &&
						const_var.ConditionArrForLean["back"][i].max_width >= params.leanB_p_w
					) {
						if (const_var.ConditionArrForLean["back"][i].is_default == "Y") {
							params.leanB_p_e_l = true;
							const_var.leanBHasDoublelegdisable = true;
							const_var.leanBHasDoublelegshow = true;

							const_var.ConditionArrForLean["back"][i].checked = const_var.crmSetting.is_Edit
								? const_var.leanBLegstype != undefined && const_var.leanBLegstype == const_var.ConditionArrForLean["back"][i].legs_type
									? true
									: false
								: true;
						} else {
							params.leanB_p_e_l = params.leanB_p_e_l ? params.leanB_p_e_l : false;
							const_var.leanBHasDoublelegdisable = false;
							const_var.leanBHasDoublelegshow = true;

							const_var.ConditionArrForLean["back"][i].checked =
								params.leanB_p_e_l && const_var.leanBLegstype != undefined && const_var.leanBLegstype == const_var.ConditionArrForLean["back"][i].legs_type ? true : false;
						}
						if (const_var.crmSetting.is_Edit && const_var.ConditionArrForLean["back"][i].checked != undefined && const_var.ConditionArrForLean["back"][i].checked) {
							const_var.leanBLegstype = const_var.ConditionArrForLean["back"][i].legs_type == "reinforced" ? "double" : const_var.ConditionArrForLean["back"][i].legs_type;
							const_var.leanBHasDoublelegName = const_var.ConditionArrForLean["back"][i].name;
						}
						const_var.reinforcedtype["back"] = const_var.ConditionArrForLean["back"][i].legs_type == "reinforced" ? "reinforced" : const_var.ConditionArrForLean["back"][i].legs_type;
					} else {
						j = j + 1;

						if (j == const_var.ConditionArrForLean["back"].length) {
							params.leanB_p_e_l = false;
							const_var.leanBHasDoublelegdisable = false;
							const_var.leanBHasDoublelegshow = false;
							const_var.leanBHasDoublelegName = "";
							const_var.leanBLegstype = "single";
						}
					}
				}
			} else {
				params.leanB_p_e_l = false;
				const_var.leanBHasDoublelegdisable = false;
				const_var.leanBHasDoublelegshow = false;
				const_var.leanBHasDoublelegName = "";
				const_var.leanBLegstype = "single";
			}

			params.leanB_p_e_l = state.defalutProductLoad == true && const_var.defaultProData.building.has_double_leg == true && const_var.CallApionAction == false ? true : params.leanB_p_e_l;
			const_var.leanBLegstype =
				state.defalutProductLoad == true && const_var.defaultProData.building.leanBLegstype != undefined && const_var.CallApionAction == false
					? const_var.defaultProData.building.legstype
					: const_var.leanBLegstype;
		}
	};

	return {
		CheckLeanLegsByResponseForCompare,
		CheckLegsByResponseForCompare,
		CheckLegsByResponse,
		CheckLeanLegsByResponse
	};
};

export const hasDoublelegBaiserail = (state, action, cuBuilding) => {
	if (
		const_var.c_f_a_per[params.p_e_i] &&
		const_var.c_f_a_per[params.p_e_i] != 0 &&
		const_var.c_f_aCer[params.p_e_i] != undefined &&
		const_var.c_f_aCer[params.p_e_i].percentage_of != undefined &&
		const_var.c_f_aCer[params.p_e_i].percentage_of &&
		const_var.c_f_aCer[params.p_e_i].percentage_of_cost > 0
	) {
		const_var.UpdatedPriceData.certificate_price_changed = true;
	}

	let updateLegsAction = "";
	if (action.buildingType === "center") {
		if (action.otherLegs === undefined) {
			state.params.p_e_l = !state.params.p_e_l;
		} else {
			state.params.p_e_l = true;
			const_var.legstype = action.otherLegs == "reinforced" ? "double" : action.otherLegs.legs_type.toLowerCase();
			const_var.hasDoublelegName = action.event;
		}
		const_var.UpdatedPriceData.height_price_changed = true;
		updateLegsAction = action.event + action.buildingType + params.p_e_l + const_var.legstype;
		updateLegsAction = action;
		if (params.fourth_center_cost) {
			calculateLegsCount();
		}
		cuBuilding.BuildingUpdate();
		cuBuilding.cP();
	}
	if (action.buildingType === "leftLean") {
		if (action.otherLegs === undefined) {
			state.params.lean_p_e_l = !state.params.lean_p_e_l;
		} else {
			state.params.lean_p_e_l = true;
			const_var.leanLegstype = action.otherLegs == "reinforced" ? "double" : action.otherLegs.legs_type;
			const_var.leanHasDoublelegName = action.event;
		}

		const_var.UpdatedPriceData.left_lean_height_price_changed = true;
		updateLegsAction = action.event + action.buildingType + params.lean_p_e_l;
		if (params.fourth_center_cost == true) {
			calculateLegsCount(const_var.leanGetDataLeft, "leftLean");
		}
		cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft);
	}
	if (action.buildingType === "rightLean") {
		if (action.otherLegs === undefined) {
			state.params.leanR_p_e_l = !state.params.leanR_p_e_l;
		} else {
			state.params.leanR_p_e_l = true;
			const_var.leanRLegstype = action.otherLegs == "reinforced" ? "double" : action.otherLegs.legs_type;
			const_var.leanRHasDoublelegName = action.event;
		}

		const_var.UpdatedPriceData.right_lean_height_price_changed = true;
		updateLegsAction = action.event + action.buildingType + params.leanR_p_e_l;
		if (params.fourth_center_cost == true) {
			calculateLegsCount(const_var.leanGetDataRight, "rightLean");
		}
		cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight);
	}
	if (action.buildingType === "frontLean") {
		if (action.otherLegs === undefined) {
			state.params.leanF_p_e_l = !state.params.leanF_p_e_l;
		} else {
			state.params.leanF_p_e_l = true;
			const_var.leanFLegstype = action.otherLegs == "reinforced" ? "double" : action.otherLegs.legs_type;
			const_var.leanFHasDoublelegName = action.event;
		}

		const_var.UpdatedPriceData.front_lean_height_price_changed = true;
		updateLegsAction = action.event + action.buildingType + params.leanF_p_e_l;
		if (params.fourth_center_cost == true) {
			calculateLegsCount(const_var.leanGetDataFront, "frontLean");
		}
		cuBuilding.cPforFLeanOnly(const_var.leanGetDataFront);
	}
	if (action.buildingType === "backLean") {
		if (action.otherLegs === undefined) {
			state.params.leanB_p_e_l = !state.params.leanB_p_e_l;
		} else {
			state.params.leanB_p_e_l = true;
			const_var.leanBLegstype = action.otherLegs == "reinforced" ? "double" : action.otherLegs.legs_type;
			const_var.leanBHasDoublelegName = action.event;
		}

		const_var.UpdatedPriceData.back_lean_height_price_changed = true;
		updateLegsAction = action.event + action.buildingType + params.leanB_p_e_l;
		if (params.fourth_center_cost == true) {
			calculateLegsCount(const_var.leanGetDataBack, "backLean");
		}
		cuBuilding.cPforBLeanOnly(const_var.leanGetDataBack);
	}

	return {
		...state,
		newColor: updateLegsAction,
		action
	};
};

export const checkLegsDataAccordingtoResponse = (dataObj, key) => {
	let chkLegs = "";
	if (key == undefined && dataObj != undefined && dataObj.length > 0) {
		chkLegs = dataObj.filter((data) => data.legs_type == const_var.legstype && (data.min_height != "" || data.min_height != null) && data.min_height <= params.p_h && data.max_height >= params.p_h);
		if (chkLegs.length == 0) {
			let newData = dataObj.filter((data) => (data.min_height != "" || data.min_height != null) && data.min_height <= params.p_h && data.max_height >= params.p_h);
			chkLegs = newData.length == 0 ? "single" : newData.length > 1 ? newData.filter((data) => data.is_default == "Y")[0].legs_type : newData[0].legs_type;
		} else {
			chkLegs = chkLegs[0]?.legs_type;
		}
	}
	if (key != undefined && key == "dimension" && dataObj != undefined && dataObj.length > 0) {
		chkLegs = dataObj.filter((data) => data.is_default == "Y" && (data.min_height != "" || data.min_height != null) && data.min_height <= params.p_h && data.max_height >= params.p_h);
		if (chkLegs.length > 0) {
			chkLegs = chkLegs[0].legs_type;
		} else {
			chkLegs = dataObj.filter((data) => (data.min_height != "" || data.min_height != null) && data.min_height <= params.p_h && data.max_height >= params.p_h);
			chkLegs = chkLegs != undefined && chkLegs.length > 0 ? chkLegs[0]?.legs_type : "single";
		}
	}
	if (const_var.crmSetting.is_Edit == true) {
		const_var.reinforcedtype["center"] = chkLegs == "reinforced" ? "reinforced" : "single";
		const_var.legstype = chkLegs != "" ? chkLegs : "single";
	} else {
		const_var.reinforcedtype["center"] = chkLegs == "reinforced" ? "reinforced" : "single";
		const_var.legstype = chkLegs != "" ? (chkLegs == "reinforced" ? "double" : chkLegs) : "single";
	}
	if (const_var.legstype) const_var.legstype = const_var.legstype.toLowerCase();
};
export const checkleanLegsDataAccordingtoResponse = (dataObj, type, key) => {
	let lean_Type = "";
	let lean_Height = "";

	if (type == "front") {
		lean_Type = const_var.leanFLegstype;
		lean_Height = params.leanF_p_h;
	}
	if (type == "back") {
		lean_Type = const_var.leanBLegstype;
		lean_Height = params.leanB_p_h;
	}
	if (type == "left") {
		lean_Type = const_var.leanLegstype;
		lean_Height = params.lean_p_h;
	}
	if (type == "right") {
		lean_Type = const_var.leanRLegstype;
		lean_Height = params.leanR_p_h;
	}
	let chkLegs = "";
	let chkLegsName = "single";
	if (key == undefined && dataObj != undefined && dataObj.length > 0) {
		chkLegs = dataObj.filter((data) => data.legs_type == lean_Type && (data.min_height != "" || data.min_height != null) && data.min_height <= params.p_h && data.max_height >= params.p_h);
		if (chkLegs.length == 0) {
			let newData = dataObj.filter((data) => (data.min_height != "" || data.min_height != null) && data.min_height <= lean_Height && data.max_height >= lean_Height);

			chkLegs = newData.length == 0 ? "single" : newData.length > 1 ? newData.filter((data) => data.is_default == "Y")[0].legs_type : newData[0].legs_type;
			chkLegsName = newData.length == 0 ? "single" : newData.length > 1 ? newData.filter((data) => data.is_default == "Y")[0].name : newData[0].name;
		} else {
			chkLegsName = chkLegs[0]?.name;
			chkLegs = chkLegs[0]?.legs_type;
		}
	}
	if (key !== undefined && key == "dimension" && dataObj != undefined && dataObj.length > 0) {
		let leanChkLegs = dataObj.filter((data) => data.is_default == "Y" && (data.min_height != "" || data.min_height != null) && data.min_height <= lean_Height && data.max_height >= lean_Height);
		if (leanChkLegs.length > 0) {
			chkLegsName = leanChkLegs[0]?.name;
			chkLegs = leanChkLegs[0]?.legs_type;
		} else {
			let newData = dataObj.filter((data) => (data.min_height != "" || data.min_height != null) && data.min_height <= lean_Height && data.max_height >= lean_Height);

			chkLegs = newData.length == 0 ? "single" : newData.length > 1 ? newData.filter((data) => data.is_default == "Y")[0].legs_type : newData[0].legs_type;
			chkLegsName = newData.length == 0 ? "single" : newData.length > 1 ? newData.filter((data) => data.is_default == "Y")[0].name : newData[0].name;
		}
	}
	if (type == "front") {
		const_var.reinforcedtype["front"] = chkLegs == "reinforced" ? "reinforced" : "single";
		const_var.leanFLegstype = chkLegs != "" ? (chkLegs == "reinforced" ? "double" : chkLegs) : "single";
		const_var.leanFHasDoublelegName = chkLegsName != "" ? chkLegsName : "single";
	}
	if (type == "back") {
		const_var.reinforcedtype["back"] = chkLegs == "reinforced" ? "reinforced" : "single";
		const_var.leanBLegstype = chkLegs != "" ? (chkLegs == "reinforced" ? "double" : chkLegs) : "single";
		const_var.leanBHasDoublelegName = chkLegsName != "" ? chkLegsName : "single";
	}
	if (type == "left") {
		const_var.reinforcedtype["left"] = chkLegs == "reinforced" ? "reinforced" : "single";
		const_var.leanLegstype = chkLegs != "" ? (chkLegs == "reinforced" ? "double" : chkLegs) : "single";
		const_var.leanHasDoublelegName = chkLegsName != "" ? chkLegsName : "single";
	}
	if (type == "right") {
		const_var.reinforcedtype["right"] = chkLegs == "reinforced" ? "reinforced" : "single";
		const_var.leanRLegstype = chkLegs != "" ? (chkLegs == "reinforced" ? "double" : chkLegs) : "single";
		const_var.leanRHasDoublelegName = chkLegsName != "" ? chkLegsName : "single";
	}
};
export const checkReinforcedLeg = (reinforcedLeg) => {
	if (reinforcedLeg != undefined && reinforcedLeg.length > 0) {
		let reinforeced = reinforcedLeg.find((data) => (data.name?.includes("Reinforced") || data.name?.includes("reinforced")) && (data.legs_type == "Single" || data.legs_type == "single"));
		if (reinforeced != undefined) {
			reinforeced.legs_type = "reinforced";
			const_var.legstype = reinforeced.legs_type;
			const_var.legstype = const_var.legstype.toLowerCase();
		}
	}
};